import { render, staticRenderFns } from "./Nodata.vue?vue&type=template&id=20fb1e20&scoped=true&"
import script from "./Nodata.vue?vue&type=script&lang=js&"
export * from "./Nodata.vue?vue&type=script&lang=js&"
import style0 from "./Nodata.vue?vue&type=style&index=0&id=20fb1e20&lang=scss&rel=stylesheet%2Fsass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20fb1e20",
  null
  
)

export default component.exports